import get from 'lodash/get';
import {calendarStates} from '../../../calendar/router';
import {showContextMenuByPermission} from '../../../core-components/context-menu/redux';
import {showManageAccess} from '../../../core-components/manage-access/redux';
import {getId} from '../../../core-utilities/domain/ReduxUtils';
import {formsStates} from '../../../forms/router';
import {updateOrgRequestModal} from '../../../organizations/redux/updateOrg';
import {personnelStates} from '../../../personnel/router';
import {projectStates} from '../../../projects/router-config';
import {isCompletableLocked} from '../../../projects/services/ParentStatusService';
import {projectTasksStates, templateTasksStates} from '../../../tasks/router-config';
import {stateGoEnter, stateGoForward} from '../../actions';
import {selectedOrganization, selectedProject} from '../../model/actions';
import {navStates} from '../../router';


export function buildOrganizationNavigationOptions({dispatch, selectFirst}) {
  const selectThenNav = (organization, navAction) => {
    if (selectFirst) {
      dispatch(selectedOrganization(getId(organization)));
    }
    dispatch(navAction);
  };
  const onEditOrg = org => dispatch(updateOrgRequestModal.actions.showModal({model: org}));
  const onNavToManageMembers = org => selectThenNav(org, stateGoEnter({state: personnelStates.membersManage}));
  const onNavToCalendar = org => selectThenNav(org, stateGoEnter({state: calendarStates.orgCalendar}));
  const onNavToPersonnel = org => selectThenNav(org, stateGoEnter({state: personnelStates.personnelHome}));
  const onNavToForms = org => selectThenNav(org, stateGoEnter({state: formsStates.forms}));
  const onNavToProjects = org => selectThenNav(org, stateGoForward({state: navStates.projectsList}));
  const onNavToAssets = org => selectThenNav(org, stateGoEnter({state: navStates.assetsList}));
  const onNavToManageAccess = org => selectThenNav(org, stateGoEnter({state: personnelStates.membersManage}));
  const onItemShowOptions = (event, org) => {
    if (!org) return;

    const actions = [];
    event.persist();

    if (get(org, 'permissions.organization_access_view'))
      actions.push({
        target: null,
        action: {
          messageId: 'organizations.nav.members.manage.label',
          action: () => onNavToManageMembers(org),
        },
      });
    actions.push({
      target: null,
      action: {
        messageId: 'mainmenu.organizations.calendar.label',
        action: () => onNavToCalendar(org),
      },
    });
    actions.push({
      target: null,
      action: {
        messageId: 'mainmenu.personnel.home.label',
        action: () => onNavToPersonnel(org),
      },
    });
    actions.push({
      target: null,
      action: {
        messageId: 'mainmenu.forms.label',
        action: () => onNavToForms(org),
      },
    });
    actions.push({
      target: null,
      action: {
        messageId: 'organizations.home.projects.label',
        action: () => onNavToProjects(org),
      },
    });
    actions.push({
      target: null,
      action: {
        messageId: 'organizations.home.assets.label',
        action: () => onNavToAssets(org),
      },
    });
    actions.push({
      target: org,
      permission: 'organization_data_edit',
      action: {
        messageId: 'organizations.nav.edit.label',
        action: () => onEditOrg(org),
      },
    });
    actions.push({
      target: org,
      permission: 'organization_access_edit',
      action: {
        messageId: 'personnel.home.context.members.manage.label',
        action: () => onNavToManageAccess(org),
      },
    });

    dispatch(showContextMenuByPermission({
      event,
      titleMessageId: selectFirst ? 'default.navigation.context.title.label' : 'default.actions.context.title.label',
      titleMessageParams: {name: org.name},
      cancelMessageId: 'defaults.context.cancel.label',
      actions,
    }));
  };

  return {
    selectThenNav,
    onEditOrg,
    onNavToManageMembers,
    onNavToCalendar,
    onNavToPersonnel,
    onNavToForms,
    onNavToProjects,
    onNavToAssets,
    onNavToManageAccess,
    onItemShowOptions,
  };
}

export function buildProjectNavigationOptions({dispatch, selectFirst}) {
  const selectThenNav = (project, navAction) => {
    if (selectFirst) {
      dispatch(selectedProject(getId(project)));
    }
    dispatch(navAction);
  };
  const onNavToTasks = project => selectThenNav(project, stateGoEnter({state: projectTasksStates.tasks}));
  const onNavToTemplate = project => selectThenNav(project, stateGoEnter({state: templateTasksStates.tasks}));
  const onNavToManageAssets = project => selectThenNav(project, stateGoEnter({
    state: projectStates.projectsManageAssets,
  }));
  // TODO: nav when management is made into a full view
  // open modal here for now
  const onOpenManageMembers = project => dispatch(showManageAccess({target: project}));
  const onItemShowOptions = (event, project) => {
    if (!project) return;

    const actions = [];
    event.persist();
    actions.push({
      target: null,
      action: {
        messageId: 'projects.tabs.tasks.list.title',
        action: () => onNavToTasks(project),
      },
    });
    actions.push({
      target: null,
      action: {
        messageId: 'projects.tabs.tasks.template.title',
        action: () => onNavToTemplate(project),
      },
    });
    actions.push({
      target: project,
      permission: isCompletableLocked(project) ? 'project_assets_create_locked' : 'project_assets_create',
      action: {
        messageId: 'projects.assets.context.manage.label',
        action: () => onNavToManageAssets(project),
      },
    });
    actions.push({
      target: null,
      action: {
        messageId: 'access.manage.project.context.label',
        action: () => onOpenManageMembers(project),
      },
    });

    dispatch(showContextMenuByPermission({
      event,
      titleMessageId: selectFirst ? 'default.navigation.context.title.label' : 'default.actions.context.title.label',
      titleMessageParams: {name: project.name},
      cancelMessageId: 'defaults.context.cancel.label',
      actions,
    }));
  };

  return {
    selectThenNav,
    onNavToTasks,
    onNavToTemplate,
    onNavToManageAssets,
    onOpenManageMembers,
    onItemShowOptions,
  };
}



// WEBPACK FOOTER //
// ./src/js/app/navigation/utils/itemActions.js